import { MessagingPlacements, PreviewModes } from '@MerchantConfigurator/constants';
import { desktopLayouts } from '@MerchantConfigurator/constants/messaging/desktopLayout';
import { mobileLayouts } from '@MerchantConfigurator/constants/messaging/mobileLayout';

export const getPreviewLayout = ({ previewMode, darkMode, activePlacement }) => {
  //todo need to create layouts for mobile layouts - https://paypal.atlassian.net/browse/DTCRCJPTR-2490
  switch (activePlacement) {
    case MessagingPlacements.cart: {
      return previewMode === PreviewModes.desktop
        ? desktopLayouts.getCartPage({
            darkMode
          })
        : mobileLayouts.getCartPage({
            darkMode
          });
    }

    case MessagingPlacements.cart_preview:
    case MessagingPlacements.mini_cart: {
      return previewMode === PreviewModes.desktop
        ? desktopLayouts.getCartPreviewPage({
            darkMode
          })
        : mobileLayouts.getCartPreviewPage({
            darkMode
          });
    }

    case MessagingPlacements.category:
    case MessagingPlacements.shop: {
      return previewMode === PreviewModes.desktop
        ? desktopLayouts.getCategoryPage({
            darkMode
          })
        : mobileLayouts.getCategoryPage({
            darkMode
          });
    }

    case MessagingPlacements.checkout: {
      return previewMode === PreviewModes.desktop
        ? desktopLayouts.getCheckoutPage({
            darkMode
          })
        : mobileLayouts.getCheckoutPage({
            darkMode
          });
    }

    case MessagingPlacements.home:
    case MessagingPlacements.homepage: {
      return previewMode === PreviewModes.desktop
        ? desktopLayouts.getHomePage({
            darkMode
          })
        : mobileLayouts.getHomePage({
            darkMode
          });
    }

    case MessagingPlacements.product: {
      return previewMode === PreviewModes.desktop
        ? desktopLayouts.getProductPage({
            darkMode
          })
        : mobileLayouts.getProductPage({
            darkMode
          });
    }

    case MessagingPlacements.product_preview: {
      return previewMode === PreviewModes.desktop
        ? desktopLayouts.getProductPreviewPage({
            darkMode
          })
        : mobileLayouts.getProductPreviewPage({
            darkMode
          });
    }

    default:
      return previewMode === PreviewModes.desktop
        ? desktopLayouts.getProductPage({
            darkMode
          })
        : mobileLayouts.getProductPage({
            darkMode
          });
  }
};
